import type { Loader } from '@googlemaps/js-api-loader';

let loaderPromise: Promise<typeof google.maps> | null = null;

/**
 * Dynamically import and initialize the Google Maps JS API.
 *
 * Memoized: a second call with the same key returns the same promise.
 */
export function loadGoogleMaps(apiKey: string): Promise<typeof google.maps> {
  if (loaderPromise) return loaderPromise;
  loaderPromise = (async () => {
    const mod = await import('@googlemaps/js-api-loader');
    const LoaderCtor = mod.Loader as typeof Loader;
    const loader = new LoaderCtor({
      apiKey,
      version: 'weekly',
      libraries: ['marker'],
      language: 'de',
      region: 'DE',
    });
    await loader.importLibrary('maps');
    await loader.importLibrary('marker');
    return google.maps;
  })();
  return loaderPromise;
}
